import * as React from "react";
import type { SVGProps } from "react";
const SvgGolfClub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#golf-club_svg__a)">
      <path d="M5.57 15h5a1 1 0 0 0 0-2h-5a1 1 0 0 0 0 2M4.57 18h10a1 1 0 0 0 0-2h-10a1 1 0 0 0 0 2" />
      <path
        fillRule="evenodd"
        d="M14.39 22H4.57a4.67 4.67 0 0 1-3.33-1.38 4.7 4.7 0 0 1-1.1-4.41l.93-3.86A5 5 0 0 1 6.7 8.58l8 1.23a.42.42 0 0 0 .47-.36v-.12l.713-2.455a1 1 0 0 1 .092-.317L17.09 2.72A1 1 0 0 1 18.32 2 1 1 0 0 1 19 3.24l-.872 3.006 2.004.504 1.038-4a1 1 0 1 1 1.94.5l-3.7 14.48A5 5 0 0 1 14.39 22m5.226-13.259L17.4 17.28a.3.3 0 0 0 0 .1A3.11 3.11 0 0 1 14.35 20H4.57a2.7 2.7 0 0 1-1.89-.79 2.68 2.68 0 0 1-.61-2.53L3 12.81a3 3 0 0 1 3.37-2.26l8 1.24a2.42 2.42 0 0 0 2.73-2l.454-1.566z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="golf-club_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGolfClub;
